import { ProgramCountryNominationReviewer, ProgramCountryNominationReviewerRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const assignProgramCountryNominationReviewer: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  programCountryNominationReviewer: ProgramCountryNominationReviewer,
  accessToken?: string,
) => Promise<ProgramCountryNominationReviewerRef> = (fetchContext, programId, countryId, programCountryNominationReviewer, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nomination-reviewers`,
  {
    method: 'POST',
    body: JSON.stringify(programCountryNominationReviewer),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<ProgramCountryNominationReviewerRef>(fetchContext.errorStore, response, 'assign program country nomination reviewer'));
